import React from 'react';
import { trans } from '@spotahome/soyuz-trans/client';
import PropTypes from 'prop-types';

import Logo from '../../../../base/Logo';

import styles from './LoginSignupModalHistoricalMetrics.module.scss';

const metrics = [
  {
    title: 'historical.bookings.number',
    text: 'historical.bookings'
  },
  {
    title: 'historical.landlords.number',
    text: 'historical.landlords'
  },
  {
    title: 'historical.homes.number',
    text: 'historical.homes'
  }
];

const MetricsItem = ({ title, text }) => (
  <div className={styles['historical-metrics__section']}>
    <div className={styles['historical-metrics__number']}>{trans(title)}</div>
    <div className={styles['historical-metrics__text']}>{trans(text)}</div>
  </div>
);

MetricsItem.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

const HistoricalMetrics = ({ isMobileDisplay }) => (
  <div className={styles['historical-metrics']}>
    {!isMobileDisplay && (
      <div>
        <Logo />
      </div>
    )}
    <div className={styles['historical-metrics__content']}>
      {metrics.map(({ title, text }) => (
        <MetricsItem title={title} text={text} key={title} />
      ))}
    </div>
  </div>
);
HistoricalMetrics.propTypes = {
  isMobileDisplay: PropTypes.bool
};
HistoricalMetrics.defaultProps = {
  isMobileDisplay: true
};

export default HistoricalMetrics;
